import React from "react";
import { ThemeProvider } from "styled-components";
import { GDSProvider, dark, light } from "@gds-react/core";
import { getGlobalTheme } from "../app/global-theme";
import { useStore } from "../store/store";
import GlobalStyle from "../app/global-style";

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeHOC = ({ children }: ThemeProviderProps) => {
  const theme = useStore.useTheme();

  return (
    <>
      <GDSProvider tokens={theme === "dark" ? dark : light}>
        <GlobalStyle theme={getGlobalTheme(theme)} />
        <ThemeProvider theme={getGlobalTheme(theme)}>{children}</ThemeProvider>
      </GDSProvider>
    </>
  );
};

export default ThemeHOC;
